/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInAppMessagesRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/ondemand/InAppMessageServiceProto.pb'
import {GetInAppMessagesResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/ondemand/InAppMessageServiceProto.pb'


export const getInAppMessages = (request: GetInAppMessagesRequest, options?: CashRequestOptions) => post<GetInAppMessagesRequest, GetInAppMessagesResponse>("/cash-app/app-messages-on-demand/get-in-app-messages", request, {...options, rejectOnError: true })